const defaultState = {
    label: 'All',
    value: 'all',
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'SET_SEARCH_BAR_CATEGORY':
            return action.category;
        default:
            return state;
    }
};
